<template>
    <b-modal id="renewContract" size="lg">
        <template slot="modal-header" slot-scope="{ close }">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-9 my-auto">
                        <h5 class="modal-title">Contract Renewal</h5>
                    </div>
                    <div class="col-3 my-auto">
                        <div>
                            <div>
                                <span><a class="close"><i class="far fa-times-circle fa-2x" @click="close()"
                                            id="closeRenewContract" aria-label="Close"></i></a></span>
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template slot="default">

            <div class="row text-center">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 mt-2">
                            <p class="font-weight-bold text-left pl-2">Signed Date</p>
                        </div>
                        <div class="col-6 mt-2">
                            <p class="font-weight-bold text-left pl-2">Start Date</p>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 el-form-item">
                            <el-date-picker v-model="signedDate" format="d MMMM yyyy" type="date"
                                :class="{ 'el-form-item is-error': submitStatus == 'VALIDATING' && $v.signedDate.$error }">
                            </el-date-picker>
                            <div v-if="submitStatus == 'VALIDATING' && !$v.signedDate.required"
                                class="ml-3 el-form-item__error">
                                Please provide a signed date.
                            </div>
                        </div>
                        <div class="col-6 el-form-item">
                            <el-date-picker v-model="startDate" format="d MMMM yyyy" type="date"
                                :class="{ 'el-form-item is-error': submitStatus == 'VALIDATING' && $v.startDate.$error }"
                                :disabled="activeContract && activeContract.ContractType === 'Agreed'">
                            </el-date-picker>
                            <div v-if="submitStatus == 'VALIDATING' && !$v.startDate.required" class="ml-3 el-form-item__error">
                                Please provide a start date.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2]">
                    <hr>
                    <div class="row">
                        <div class="col-6 mt-2">
                            <p class="font-weight-bold text-left pl-2">End Date</p>
                        </div>
                        <div class="col-6 mt-2">
                            <p class="font-weight-bold text-left pl-2">Notice Period</p>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 el-form-item">
                            <el-date-picker v-model="endDate" format="d MMMM yyyy" type="date"
                                :class="{ 'el-form-item is-error': submitStatus == 'VALIDATING' && $v.endDate.$error }">
                            </el-date-picker>
                            <div v-if="submitStatus == 'VALIDATING' && !$v.endDate.required" class="ml-3 el-form-item__error">
                                Please provide an end date.
                            </div>
                        </div>
                        <div class="col-6 d-flex align-items-start el-form-item">
                            <!-- <span class="d-flex align-items-start"> -->
                            <el-input type="number" class="w-50 text-center" v-model="noticePeriod" append="days"
                                 :class="{ 'el-form-item is-error': submitStatus == 'VALIDATING' && $v.noticePeriod.$error }">
                                 <template slot="append">days</template>
                            </el-input>
                            <!-- <p class="d-inline pb-1 pt-2 pl-2"> days</p></span> -->
                            <div v-if="submitStatus == 'VALIDATING' && !$v.noticePeriod.required"
                                class="ml-3 el-form-item__error">
                                Please provide a notice period.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                        <div>
                            <p class="font-weight-bold text-left pl-2">Contract Type</p>
                        </div>
                  <b-form-select
                    v-model="contractType"
                    class="form-control"
                    required
                  >
                    <option value="Agreed">Agreed</option>
                    <option value="Deemed">Deemed</option>
                  </b-form-select>
                </div>

                <div class="col-12 mt-2">
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <p class="font-weight-bold text-left pl-2" v-if="!selectedBundle">Search for a Service Bundle
                            </p>
                            <p class="font-weight-bold text-left pl-2" v-if="selectedBundle">Selected Service Bundle</p>
                        </div>
                        <div class="col-12">
                            <div class="input-group" v-if="!selectedBundle">
                                <input v-model="serviceBundleSearch" @keyup="search()" @paste="search($event)" type="text"
                                    class="form-control underline" name="Search for a bundle"
                                    :class="{ 'underline-error': submitStatus == 'VALIDATING' && $v.selectedBundle.$error }"
                                    placeholder="Start typing to search..." pattern="^[A-Za-z -]+$" />
                                <div v-if="submitStatus == 'VALIDATING' && !$v.selectedBundle.required"
                                    class="el-form-item__error">
                                    Please select a service bundle.
                                </div>
                            </div>
                            <!-- This button only appears when a bundle has been selected -->

                            <div class="d-flex align-items-end flex-column h-100" v-if="selectedBundle">
                                <template>
                                    <b-table responsive outlined striped :items="[selectedBundle]"
                                        :fields="selectedBundleFields">
                                        <template slot="name" slot-scope="data">
                                            {{data.item.ServiceBundleName}}
                                        </template>
                                        <template slot="description" slot-scope="data">
                                            {{data.item.ServiceBundleDescription}}
                                        </template>
                                        <template slot="action">
                                            <a href='#' onclick="return false;" @click="clearSelection"><img
                                                    src="@/assets/img/remove_icon.png"></a>
                                        </template>
                                    </b-table>
                                </template>
                            </div>

                            <!-- This is where the search results start -->
                            <div class="col no-pad bg-white">
                                <div
                                  class="row"
                                  v-if="(results && (results == 0 || !results)) && (serviceBundleSearch && serviceBundleSearch.length > 0)"
                                >
                                  <div class="col-12">
                                    <div class="mx-auto p-3">
                                      <h5>Search Results:</h5>
                                      <p class="d-inline">Sorry, no results found. Please, try again.</p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="row"
                                  v-else-if="results && results.length >= 1 && serviceBundleSearch.length > 2"
                                >
                                  <div class="col-sm">
                                    <div class="mx-auto p-3">
                                      <template>
                                        <b-list-group>
                                          <b-list-group-item
                                            href="#"
                                            @click="selectServiceBundle(result)"
                                            v-for="(result, rIndex) in results"
                                            :key="rIndex"
                                          >{{result.Document.ServiceBundleName}}</b-list-group-item>
                                        </b-list-group>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <!-- This is where the search results end -->

                        </div>
                    </div>
                </div>
            </div>

            <span v-if="showHhNhhMapping">
              <hr>

              <p class="font-weight-bold text-left pl-2">HH NHH Mapping</p>

              <div class="row">
                <div class="col">
                  <b-form-select class="form-control" name="selection" required v-model="hhNhhMapping">
                    <option :value="null">Not Applicable</option>
                    <option v-for="mapping in HHNHHMappings" :key="mapping.value" :value="mapping.value">{{mapping.label}}</option>
                  </b-form-select>
                </div>
              </div>
            </span>
        </template>

        <template slot="modal-footer">
            <button type="submit" class="btn btn-hc float-right" @click="renewContract()"
        :disabled="submitStatus == 'PENDING' || showHhNhhMapping && hhNhhMapping === undefined">Confirm</button>
        </template>
    </b-modal>

</template>

<script>
import moment from 'moment';
import Vue from 'vue';

import { required } from 'vuelidate/lib/validators';

export default {
	data() {
		return {
			// signedDate: moment().format('YYYY-MM-DD'),
			// endDate: moment().format('YYYY-MM-DD'),
			submitStatus: null,
			noticePeriod: 30,
			serviceBundleSearch: '', // Vuex-backed search string
			selectedBundle: null,
			p_hhNhhMapping: undefined,
			searchResultFields: {
				name: {
					key: 'Document.ServiceBundleName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'Document.ServiceBundleDescription',
					label: 'Description',
					class: 'text-center',
				},
			},
			selectedBundleFields: {
				name: {
					key: 'ServiceBundleName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'ServiceBundleDescription',
					label: 'Description',
					class: 'text-center',
				},
				action: {
					label: '',
					class: 'text-center',
				},
			},
		};
	},
	validations() {
		return {
			signedDate: {
				required,
			},
			startDate: {
				required,
			},
			endDate: {
				required,
			},
			noticePeriod: {
				required,
			},
			selectedBundle: {
				required,
			},
		};
	},
	computed: {
		results() {
			// return this.$store.state.results;
			let that = this;

			// Filtering returned search for service bundles that are relevent to the selected services
			return this.$_.filter(this.$store.state.serviceBundleResults, function(
				transferSearch
			) {
				return that.checkCompatibility(transferSearch.Document.ServiceTypes);
			});
		},
		activeContract: {
			get() {
				return this.$store.state.contracts.activeContract;
			},
			set(contract) {
				this.$store.commit('updateActiveContract', contract);
			},
		},
		signedDate: {
			get() {
				return this.$store.state.contracts.renewalSignedDate;
			},
			set(date) {
				this.$store.commit('updateRenewalSignedDate', date);
			},
		},
		startDate: {
			get() {
				if (
					this.activeContract &&
					this.activeContract.ContractType === 'Agreed'
				)
					return this.activeContract.EndDate;
				return this.$store.state.contracts.renewalStartDate;
			},
			set(date) {
				this.$store.commit('updateRenewalStartDate', date);
			},
		},
		endDate: {
			get() {
				return this.$store.state.contracts.renewalEndDate;
			},
			set(date) {
				this.$store.commit('updateRenewalEndDate', date);
			},
		},
		contractType: {
			get() {
				return this.$store.state.contracts.renewalContractType;
			},
			set(date) {
				this.$store.commit('updateRenewalContractType', date);
			},
		},
		activeBundle: {
			get() {
				return this.$store.state.contracts.activeBundle;
			},
			set(bundle) {
				this.$store.commit('updateActiveBundle', bundle);
			},
		},
		services() {
			if (!this.$store.state.contracts.services) return;

			return this.$store.state.contracts.services.filter(
				(s) => s.Contract.Id === this.activeContract.Id
			);
		},
		serviceTypes() {
			let serviceTypes = [];
			this.activeContract.Services.forEach((service) => {
				serviceTypes.push(service.ServiceType);
			});
			return this.$_.uniq(serviceTypes);
		},

		hhNhhMapping: {
			get() {
				return this.p_hhNhhMapping !== undefined
					? this.p_hhNhhMapping
					: this.currentMapping;
			},
			set(v) {
				this.p_hhNhhMapping = v;
			},
		},

		HHNHHMappings() {
			return this.$store.state.contracts.hhnhhmappings.filter(
				(m) => m.isVisible || this.currentMapping === m.value
			);
		},

		showHhNhhMapping() {
			return (
				this.selectedBundle &&
				this.services.some((service) => {
					return (
						service.MeterPoint.MeterPointConfigs.some(
							(config) => config.MeasurementMethod === 'HalfHourly')
					);
				})
			);
		},

		currentMapping() {
			if (!this.$store.state.contracts.activeContract) return null;

			return this.$store.state.contracts.activeContract.Services.flatMap(
				(s) =>
					s.ElectricityDetails
						? s.ElectricityDetails.CommercialConfigurations
						: null
			)
				.map((p) => p && p.HhNhhMappingId)
				.filter((p) => p)
				.reduce((acc, n) => (acc ? null : n), null);
		},

		hhTariffs() {
			if (
				!this.completeServiceBundle ||
				!Array.isArray(this.completeServiceBundle.TariffVersions)
			)
				return [];

			return this.completeServiceBundle.TariffVersions.filter(
				(p) =>
					moment(this.startDate).isBetween(p.EffectiveFrom, p.EffectiveTo) &&
					p.HhElectricityDetails &&
					p.HhElectricityDetails.length
			);
		},
		completeServiceBundle() {
			return this.$store.state.completeServiceBundle;
		},
	},
	watch: {
		selectedBundle(newValue, oldValue) {
			if (newValue === null) {
				this.$store.commit('updateCompleteServiceBundle', null);
			} else {
				this.$store.dispatch(
					'getCompleteServiceBundle',
					newValue.ServiceBundleId
				);
			}
		},
	},
	methods: {
		checkCompatibility(serviceBundleTypes) {
			let isCompatible = true;
			this.serviceTypes.forEach((serviceType) => {
				isCompatible = serviceBundleTypes.includes(serviceType)
					? isCompatible
					: false;
			});

			return isCompatible;
		},
		search(ev) {
			this.$store.dispatch('serviceBundleSearch', {
				Criteria: this.serviceBundleSearch,
				Index: 'Export',
			});
		},
		selectServiceBundle(item) {
			this.$store.commit('updateresults', { Results: null });
			this.serviceBundleSearch = '';
			this.selectedBundle = item.Document ? item.Document : item;
			this.$store.dispatch(
				'getCompleteServiceBundle',
				this.selectedBundle.ServiceBundleId
			);
		},
		clearSelection() {
			this.selectedBundle = null;
		},
		renewContract() {
			this.submitStatus = 'VALIDATING';
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.submitStatus = 'PENDING';
				this.$http
					.post(
						'https://' +
							Vue.config.honeycomb.queenbee.domain +
							'/api/v1/contracts',
						{
							ContractId: this.activeContract.Id,
							SignedDate: moment
								.utc(moment(this.signedDate).format('YYYY-MM-DD'))
								.format(),
							StartDate: moment
								.utc(moment(this.startDate).format('YYYY-MM-DD'))
								.format(),
							EndDate: moment
								.utc(moment(this.endDate).format('YYYY-MM-DD'))
								.format(),
							ContractType: this.contractType,
							NoticePeriodDays: parseInt(this.noticePeriod),
							ServiceBundleId: this.completeServiceBundle.SharedId,
							HhNhhMapping: this.hhNhhMapping,
						},
						{
							withCredentials: true,
						}
					)
					.then((response) => {
						this.submitStatus = 'OK';
						this.noticePeriod = 30;
						this.serviceBundleSearch = '';
						this.selectedBundle = null;
						this.hhNhhMapping = undefined;
						this.$snotify.success(`Success! Contract renewed.`);
						this.$store.dispatch('getContracts');
						this.activeContract = response.data;
						document.getElementById('closeRenewContract').click();
					})
					.catch((error) => {
						this.submitStatus = 'ERROR';
						if (error.response) {
							if (error.response.data.MoreInformation.length > 0) {
								error.response.data.MoreInformation.forEach((e) => {
									this.$snotify.error(`${e.Error}`, {
										timeout: 0,
										closeOnClick: true,
									});
								});
							} else {
								this.$snotify.error(`${error.response.data.UserDescription}`, {
									timeout: 0,
									closeOnClick: true,
								});
							}
						} else if (error.request) {
							this.$snotify.error(`No response recieved.`, {
								timeout: 0,
								closeOnClick: true,
							});
						} else {
							this.$snotify.error(`${error.message}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					});
			}
		},
	},
};
</script>
